import React from 'react'
import PropTypes from 'prop-types'
import { toUpper, isNil } from 'lodash'
import { Menu, MenuButton, MenuItem, MenuDropdown } from './Shared'

const VcenterSubMenu = ({ vcenter }) => {
  if (isNil(vcenter)) {
    return 'Unknown vCenter'
  }

  return (
    <Menu>
      <MenuButton text={toUpper(vcenter.name)} textToCopy={vcenter.name} />

      <MenuDropdown>
        <MenuItem text={'Console'} href={`https://${vcenter.ip}/ui`} />
        <MenuItem text={'Configuration report'} href={vcenter.configuration_report} />
        <MenuItem text={'Configuration history'} href={`https://dev.azure.com/CalligoScripting/Scripting/_git/gitops_vsphere_configuration?path=/vsphere_reports/${vcenter.site_code}/${toUpper(vcenter.name)}.txt`} />
      </MenuDropdown>
    </Menu>
  )
}

export default VcenterSubMenu
